// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__edisT","navbarlink":"Navbar_navbarlink__ItGN+","navbarlinkactive":"Navbar_navbarlinkactive__NxBCq"};